import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import { Fieldset } from '../Fieldset/Fieldset.js';
import '../Fieldset/Legend.js';
import style from './RadioCardGroup.module.scss.js';

const { componentTestLabel } = getTestLabels('RadioCardGroup');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=3484-105229&node-type=section&t=L12XIxh9aK1lGzgC-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Form/RadioCardGroup/RadioCardGroup.tsx)
 *
 * For grouping [RadioCard](https://ui-components.private.zooplus.net/?path=/docs/components-form-radiocard) components
 * together into an [HTML fieldset element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/fieldset).
 * Remember that all nested RadioCard components must have the same `name` attribute/prop.
 *
 * @param {string} legendText - (optional) If provided, will render as an HTML `<legend>` as the first child of the `<fieldset>`.
 *   This prop accepts plain strings or React/HTML markup but note that only phrasing content and h1-h6 elements are permitted
 *   inside of legend elements (see [MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/legend#technical_summary))
 */
const RadioCardGroup = forwardRef((props, ref) => {
    const { children, className, legendText, ...otherProps } = props;
    return (jsx(Fieldset, { "data-zta": componentTestLabel, ref: ref, className: classNames(className, style['z-radio-card-group']), legendText: legendText, ...otherProps, children: children }));
});
RadioCardGroup.displayName = 'RadioCardGroup';

export { RadioCardGroup };
//# sourceMappingURL=RadioCardGroup.js.map
